import { VendorTieredDiscountCodeModel } from '@codegen-basetypes';
import React from 'react';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import styles from './SaleTreatmentBanner.module.scss';

interface SaleTreatmentBannerProps {
  vendorTieredDiscountCode: VendorTieredDiscountCodeModel;
  className?: string;
}

const SaleTreatmentBanner = ({ vendorTieredDiscountCode, className = '' }: SaleTreatmentBannerProps) => {
  const theme = useTheme();
  const { maxSavingsPercentage } = vendorTieredDiscountCode;
  const tieredDiscountBannerText = `Save up to ${maxSavingsPercentage}%`;

  return (
    <div className={classNames(className, styles.Sale, theme.styles.Overline)}>
      {tieredDiscountBannerText}
    </div>
  );
};

export default SaleTreatmentBanner;
